/* Lumiva — main product section (gallery, variant picker, Kaching-aware form,
   countdown, low stock, mini reviews, accordion, size finder). */
(function () {
  "use strict";

  var $ = function (s, c) {
    return (c || document).querySelector(s);
  };
  var $$ = function (s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  };
  var L = (window.Lumiva = window.Lumiva || {});

  /* ---------------- helpers ---------------- */
  function money(cents, fmt) {
    if (typeof L.formatMoney === "function") return L.formatMoney(cents);
    var v = (cents / 100).toFixed(2);
    var parts = v.split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (fmt || "${{amount}}").replace(
      /\{\{\s*(\w+)\s*\}\}/,
      function (_, k) {
        if (k === "amount_no_decimals") return whole;
        if (k === "amount_with_comma_separator")
          return (
            parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + parts[1]
          );
        return whole + "." + parts[1];
      },
    );
  }

  function toast(msg) {
    if (typeof L.toast === "function") return L.toast(msg);
    var t = $("#LumivaToast");
    if (!t) {
      t = document.createElement("div");
      t.id = "LumivaToast";
      t.className = "toast";
      t.setAttribute("role", "status");
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(t._h);
    t._h = setTimeout(function () {
      t.classList.remove("show");
    }, 2400);
  }

  var pad = function (n) {
    return (n < 10 ? "0" : "") + n;
  };

  /* ---------------- countdown (one global ticker) ---------------- */
  function startCountdown() {
    if (L._lvTicker) return;
    function endOfDay() {
      var d = new Date();
      d.setHours(23, 59, 59, 999);
      return d.getTime();
    }
    L.deadline = endOfDay();
    function tick() {
      if (Date.now() > L.deadline) L.deadline = endOfDay();
      var d = Math.max(0, L.deadline - Date.now()) / 1000;
      var t = {
        h: pad(Math.floor(d / 3600)),
        m: pad(Math.floor((d % 3600) / 60)),
        s: pad(Math.floor(d % 60)),
      };
      $$("[data-timer]").forEach(function (el) {
        var h = $("[data-h]", el),
          m = $("[data-m]", el),
          s = $("[data-s]", el);
        if (h) h.textContent = t.h;
        if (m) m.textContent = t.m;
        if (s) s.textContent = t.s;
      });
      document.dispatchEvent(new CustomEvent("lumiva:tick", { detail: t }));
    }
    tick();
    L._lvTicker = setInterval(tick, 1000);
  }

  /* ---------------- bundle app (Kaching) detection ---------------- */
  var APP_SEL =
    '.shopify-app-block, kaching-bundles, kaching-bundles-block, [class*="kaching" i], [id*="kaching" i]';
  function hasBundleApp(root) {
    var slot = $("[data-app-slot]", root);
    if (slot && slot.querySelector(APP_SEL)) return true;
    return !!document.querySelector(
      'kaching-bundles, kaching-bundles-block, [class*="kaching-bundles" i], [id*="kaching" i]',
    );
  }

  /* ---------------- section init ---------------- */
  function init(root) {
    if (!root || root._lv) return;
    root._lv = true;
    var jsonEl = $("[data-product-json]", root);
    var data = null;
    try {
      data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    } catch (e) {
      data = null;
    }
    var S = (data && data.strings) || {};

    /* ----- gallery ----- */
    var slides = $$(".g-slide", root);
    var thumbs = $$("[data-thumb]", root);
    function showMedia(id) {
      id = String(id);
      var found = slides.some(function (s) {
        return s.getAttribute("data-media-id") === id;
      });
      if (!found) return;
      slides.forEach(function (s) {
        var on = s.getAttribute("data-media-id") === id;
        s.hidden = !on;
        s.classList.toggle("on", on);
        if (on)
          $$("video", s).forEach(function (v) {
            v.muted = true;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          });
        if (!on)
          $$("video", s).forEach(function (v) {
            try {
              v.pause();
            } catch (e) {}
          });
      });
      thumbs.forEach(function (t) {
        var on = t.getAttribute("data-thumb") === id;
        t.classList.toggle("on", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
        if (on) revealThumb(t);
      });
      if (typeof syncDots === "function") syncDots();
    }
    /* horizontal thumb strip: keep the active thumb visible, arrows on desktop */
    var strip = $("[data-thumbs]", root);
    var tPrev = $("[data-thumbs-prev]", root);
    var tNext = $("[data-thumbs-next]", root);
    function revealThumb(t) {
      if (!strip) return;
      var l = t.offsetLeft - strip.offsetLeft,
        r = l + t.offsetWidth;
      if (l < strip.scrollLeft) strip.scrollLeft = l;
      else if (r > strip.scrollLeft + strip.clientWidth)
        strip.scrollLeft = r - strip.clientWidth;
    }
    function syncNav() {
      if (!strip) return;
      var max = strip.scrollWidth - strip.clientWidth - 2;
      if (tPrev) tPrev.hidden = strip.scrollLeft <= 2;
      if (tNext) tNext.hidden = strip.scrollLeft >= max;
    }
    if (strip) {
      strip.addEventListener("scroll", syncNav, { passive: true });
      window.addEventListener("resize", syncNav);
      requestAnimationFrame(syncNav);
      [
        [tPrev, -1],
        [tNext, 1],
      ].forEach(function (p) {
        if (p[0])
          p[0].addEventListener("click", function () {
            strip.scrollLeft += p[1] * strip.clientWidth * 0.8;
          });
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        showMedia(t.getAttribute("data-thumb"));
      });
    });
    /* prev / next arrows + dots under the main image */
    function stepMedia(d) {
      var cur = slides.findIndex(function (s) {
        return !s.hidden;
      });
      var next = (cur + d + slides.length) % slides.length;
      showMedia(slides[next].getAttribute("data-media-id"));
    }
    var gDots = $("[data-g-dots]", root);
    function syncDots() {
      if (!gDots) return;
      var cur = slides.findIndex(function (s) {
        return !s.hidden;
      });
      $$("i", gDots).forEach(function (d, k) {
        d.classList.toggle("on", k === cur);
      });
    }
    if (gDots && slides.length > 1) {
      gDots.innerHTML = slides
        .map(function () {
          return "<i></i>";
        })
        .join("");
      syncDots();
      var gPrev = $("[data-g-prev]", root),
        gNext = $("[data-g-next]", root);
      if (gPrev)
        gPrev.addEventListener("click", function () {
          stepMedia(-1);
        });
      if (gNext)
        gNext.addEventListener("click", function () {
          stepMedia(1);
        });
    }
    /* swipe on main image */
    var gmain = $(".g-main", root);
    if (gmain && slides.length > 1) {
      var x0 = null;
      gmain.addEventListener(
        "touchstart",
        function (e) {
          x0 = e.touches[0].clientX;
        },
        { passive: true },
      );
      gmain.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 40) return;
        stepMedia(dx < 0 ? 1 : -1);
      });
    }

    /* ----- variant picker + form ----- */
    var form = $("form[data-lv-form]", root);
    var idInput = form && $("[data-variant-id]", form);
    var atc = form && $("[data-atc]", form);
    var atcLabel = atc && $("[data-atc-label]", atc);
    var atcPrice = atc && $("[data-atc-price]", atc);
    var errEl = form && $("[data-atc-err]", form);
    var picker = $("[data-picker]", root);
    var variants = (data && data.variants) || [];
    var ci = data ? data.colorIndex : -1;
    var si = data ? data.sizeIndex : -1;
    var current = null;
    if (idInput) {
      var cid = Number(idInput.value);
      current =
        variants.filter(function (v) {
          return v.id === cid;
        })[0] ||
        variants[0] ||
        null;
    }
    var chosen = current ? current.options.slice() : [];

    function findVariant(opts) {
      var exact = variants.filter(function (v) {
        return v.options.every(function (o, i) {
          return o === opts[i];
        });
      })[0];
      return exact || null;
    }

    function syncSwatches() {
      if (!picker || ci < 0) return;
      $$(".sw button", picker).forEach(function (b) {
        var val = b.getAttribute("data-value");
        var on = val === chosen[ci];
        b.classList.toggle("on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
        var test = chosen.slice();
        test[ci] = val;
        var v = findVariant(test);
        b.classList.toggle("na", !v || !v.available);
      });
      var nameEl = $("[data-color-name]", picker);
      if (nameEl) nameEl.textContent = chosen[ci];
      syncSizes();
    }

    /* sizes that don't exist / are sold out in the chosen colour: label + disable */
    function sizeOk(size) {
      var test = chosen.slice();
      test[si] = size;
      var v = findVariant(test);
      return !!(v && v.available);
    }
    function syncSizes() {
      var sel = picker && si >= 0 && $("[data-size]", picker);
      if (!sel) return;
      $$("option", sel).forEach(function (o) {
        if (o.__label === undefined) o.__label = o.textContent;
        var ok = sizeOk(o.value);
        o.textContent =
          o.__label +
          (ok ? "" : " — " + (S.soldOut || "Sold out").toLowerCase());
        o.disabled = !ok;
      });
      sel.value = chosen[si];
    }
    function firstOkSize() {
      var sel = picker && si >= 0 && $("[data-size]", picker);
      if (!sel) return null;
      var o = $$("option", sel).filter(function (x) {
        return sizeOk(x.value);
      })[0];
      return o ? o.value : null;
    }

    function setATC(state) {
      if (!atc) return;
      if (state === "ok") {
        atc.disabled = false;
        if (atcLabel) atcLabel.textContent = S.atc || "Add to cart";
      } else {
        atc.disabled = true;
        if (atcLabel)
          atcLabel.textContent =
            state === "soldout"
              ? S.soldOut || "Sold out"
              : S.unavailable || "Unavailable";
      }
      var wrap = $("[data-atc-price-wrap]", atc);
      if (wrap) wrap.hidden = state !== "ok";
    }

    function applyVariant(updateUrl) {
      var v = findVariant(chosen);
      current = v;
      syncSwatches();
      if (!v) {
        setATC("na");
        return;
      }
      if (idInput) idInput.value = v.id;
      if (atcPrice)
        atcPrice.textContent = money(v.price, data && data.moneyFormat);
      setATC(v.available ? "ok" : "soldout");
      if (v.media) showMedia(v.media);
      if (
        updateUrl &&
        window.history &&
        window.history.replaceState &&
        /\/products\//.test(location.pathname)
      ) {
        var u = new URL(location.href);
        u.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", u.toString());
      }
      root.dispatchEvent(
        new CustomEvent("lumiva:variant", {
          bubbles: true,
          detail: { variant: v },
        }),
      );
    }

    if (picker) {
      picker.addEventListener("click", function (e) {
        var b = e.target.closest(".sw button");
        if (!b || ci < 0) return;
        e.preventDefault();
        chosen[ci] = b.getAttribute("data-value");
        if (si >= 0 && !sizeOk(chosen[si])) {
          var alt = firstOkSize();
          if (alt) chosen[si] = alt;
        }
        applyVariant(true);
      });
      picker.addEventListener("change", function (e) {
        var t = e.target;
        if (t.matches("[data-size]") && si >= 0) chosen[si] = t.value;
        else if (t.hasAttribute("data-option"))
          chosen[Number(t.getAttribute("data-option"))] = t.value;
        else return;
        applyVariant(true);
      });
      syncSwatches();
    }

    /* Kaching present? hide theme picker (auto mode) + price in button */
    function checkApp() {
      var on = hasBundleApp(root);
      root.classList.toggle("has-bundle-app", on);
      return on;
    }
    checkApp();
    var slot = $("[data-app-slot]", root);
    if (slot && "MutationObserver" in window) {
      var mo = new MutationObserver(checkApp);
      mo.observe(slot, { childList: true, subtree: true });
      setTimeout(function () {
        mo.disconnect();
      }, 15000);
    }
    window.addEventListener("load", checkApp);

    if (form) {
      /* Bundle app (Kaching) present: add via AJAX instead of a form POST.
         Kaching patches fetch and swaps the request body for the bundle items,
         so we only have to refresh the cart drawer and open it (no /cart redirect). */
      var bundleBusy = false;
      function bundleAdd(e) {
        if (!checkApp() || typeof L.addItems !== "function" || !idInput) return;
        if (e.defaultPrevented) return; /* Kaching blocked it (validation) */
        e.preventDefault();
        if (bundleBusy) return;
        bundleBusy = true;
        if (atc) atc.classList.add("is-loading");
        if (errEl) errEl.hidden = true;
        L.addItems([{ id: Number(idInput.value), quantity: 1 }], {
          silent: true,
        })
          .then(function () {
            return L.refreshCart ? L.refreshCart() : null;
          })
          .then(function () {
            if (L.afterAdd) L.afterAdd();
          })
          .catch(function (err) {
            if (errEl) {
              errEl.textContent = (err && err.message) || "Error";
              errEl.hidden = false;
            }
          })
          .then(function () {
            bundleBusy = false;
            if (atc) atc.classList.remove("is-loading");
          });
      }
      if (atc) atc.addEventListener("click", bundleAdd);
      form.addEventListener("submit", function (e) {
        if (checkApp()) return bundleAdd(e);
        if (typeof L.addItems !== "function" || !idInput)
          return; /* native POST /cart/add */
        e.preventDefault();
        if (atc) atc.disabled = true;
        if (errEl) errEl.hidden = true;
        L.addItems([{ id: Number(idInput.value), quantity: 1 }])
          .then(function () {
            if (S.added) toast(S.added);
          })
          .catch(function (err) {
            if (errEl) {
              errEl.textContent = (err && err.message) || "Error";
              errEl.hidden = false;
            }
          })
          .then(function () {
            if (atc) atc.disabled = !(current && current.available);
          });
      });
    }

    /* ----- sticky buy bar: visible once the buy box has scrolled above the viewport ----- */
    var sticky = $("[data-lv-sticky]", root);
    var buyArea = $("#lv-buy", root) || atc;
    if (sticky && buyArea) {
      document.body.appendChild(sticky);
      var stickyLink = $("a", sticky);
      var pastBuy = false;
      function syncSticky() {
        var r = buyArea.getBoundingClientRect();
        var a = atc ? atc.getBoundingClientRect() : r;
        var below = Math.max(r.bottom, a.bottom) < 0;
        var drawerOpen = !!document.querySelector(".drawer.open");
        var on = below && !drawerOpen;
        if (on !== pastBuy) {
          pastBuy = on;
          sticky.classList.toggle("is-on", on);
          sticky.setAttribute("aria-hidden", on ? "false" : "true");
          if (stickyLink) stickyLink.tabIndex = on ? 0 : -1;
        }
      }
      window.addEventListener("scroll", syncSticky, { passive: true });
      window.addEventListener("resize", syncSticky);
      document.addEventListener("click", function () {
        setTimeout(syncSticky, 50);
      });
      syncSticky();
    }

    /* ----- low stock jitter ----- */
    var stock = $("[data-stock]", root);
    if (stock) {
      var nEl = $("[data-stock-n]", stock),
        soldEl = $("[data-stock-sold]", stock),
        bar = $("[data-stock-bar]", stock);
      var start = Number(stock.getAttribute("data-start")) || 17;
      var sold0 = Number(stock.getAttribute("data-sold")) || 83;
      var n = start;
      var key = "lv_stock_" + (root.getAttribute("data-section") || "");
      try {
        var saved = Number(sessionStorage.getItem(key));
        if (saved && saved <= start && saved >= 3) n = saved;
      } catch (e) {}
      function paint() {
        var pct = Math.min(
          97,
          Math.round(
            sold0 + (start - n) * ((97 - sold0) / Math.max(1, start - 3)),
          ),
        );
        if (nEl) nEl.textContent = n;
        if (soldEl) soldEl.textContent = pct;
        if (bar) bar.style.width = pct + "%";
      }
      paint();
      setInterval(function () {
        if (n > 4 && Math.random() < 0.3) {
          n -= 1;
          try {
            sessionStorage.setItem(key, n);
          } catch (e) {}
          paint();
        }
      }, 9000);
    }

    /* ----- mini review slider ----- */
    var track = $("[data-mini-track]", root);
    var dotsEl = $("[data-mini-dots]", root);
    if (track && dotsEl) {
      var count = track.children.length;
      var idx = 0,
        timer;
      dotsEl.innerHTML = "";
      for (var k = 0; k < count; k++) {
        var d = document.createElement("button");
        d.type = "button";
        d.setAttribute("aria-label", "Review " + (k + 1));
        dotsEl.appendChild(d);
      }
      var dots = $$("button", dotsEl);
      var go = function (i) {
        idx = (i + count) % count;
        track.style.transform = "translateX(-" + idx * 100 + "%)";
        dots.forEach(function (d, j) {
          d.classList.toggle("on", j === idx);
        });
      };
      var auto = function () {
        clearInterval(timer);
        if (count > 1)
          timer = setInterval(function () {
            go(idx + 1);
          }, 5500);
      };
      dots.forEach(function (d, j) {
        d.addEventListener("click", function () {
          go(j);
          auto();
        });
      });
      var tx = null;
      track.addEventListener(
        "touchstart",
        function (e) {
          tx = e.touches[0].clientX;
        },
        { passive: true },
      );
      track.addEventListener("touchend", function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        tx = null;
        if (Math.abs(dx) > 40) {
          go(idx + (dx < 0 ? 1 : -1));
          auto();
        }
      });
      root._miniGo = function (el) {
        var i = Array.prototype.indexOf.call(track.children, el);
        if (i >= 0) {
          go(i);
          clearInterval(timer);
        }
      };
      go(0);
      auto();
    }

    /* ----- accordion ----- */
    $$("[data-acc]", root).forEach(function (acc) {
      acc.addEventListener("click", function (e) {
        var q = e.target.closest(".acc-q");
        if (!q || !acc.contains(q)) return;
        var item = q.parentNode;
        var was = item.classList.contains("open");
        $$(".acc-i", acc).forEach(function (x) {
          x.classList.remove("open");
          var b = $(".acc-q", x);
          if (b) b.setAttribute("aria-expanded", "false");
        });
        if (!was) {
          item.classList.add("open");
          q.setAttribute("aria-expanded", "true");
        }
      });
    });

    /* ----- size finder ----- */
    initSizeFinder(root, data, function (size) {
      var sel = picker && $("[data-size]", picker);
      var visible = sel && sel.offsetParent !== null;
      if (sel && size) {
        var match = $$("option", sel).filter(function (o) {
          return o.value.toLowerCase() === size.toLowerCase();
        })[0];
        if (match) {
          sel.value = match.value;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
      var tpl = visible ? S.sizeApplied : S.sizeSelected || S.sizeApplied;
      if (size && tpl) toast(tpl.replace("[size]", size));
      var buy = $("#lv-buy") || form;
      if (buy) buy.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    startCountdown();
  }

  /* ---------------- size finder ---------------- */
  function initSizeFinder(root, data, onApply) {
    var m = $("[data-size-modal]", root);
    var opener = $("[data-size-open]", root);
    if (!m || !opener) return;
    if (m.parentNode !== document.body) {
      /* move to body so fixed positioning isn't trapped by transformed ancestors */
      m.setAttribute("data-owner", root.getAttribute("data-section") || "");
      document.body.appendChild(m);
    }

    var rows = [];
    try {
      var raw = JSON.parse($("[data-size-table]", m).textContent) || "";
      raw.split(/\r?\n/).forEach(function (line) {
        var p = line.split("|").map(function (x) {
          return x.trim();
        });
        if (p.length >= 4 && p[0]) {
          rows.push([
            p[0],
            p[1] || "",
            parseFloat(p[2]),
            parseFloat(p[3]),
            parseFloat(p[4]),
            parseFloat(p[5]),
          ]);
        }
      });
    } catch (e) {}

    var unit = "in",
      rec = null,
      lastFocus = null;
    var waist = $("[data-size-waist]", m);
    var unitLbl = $("[data-size-unit]", m);
    var chart = $("[data-size-chart]", m);
    var res = $("[data-size-res]", m);
    var err = $("[data-size-err]", m);
    var applyBtn = $("[data-size-apply]", m);
    var applyDefault = applyBtn ? applyBtn.textContent : "";

    function fmt(v) {
      if (isNaN(v)) return "–";
      return unit === "cm"
        ? String(Math.round(v * 2.54))
        : String(v).replace(".5", "½");
    }
    var hasHips = rows.some(function (r) {
      return !isNaN(r[4]);
    });
    var hipsH = $("[data-size-hips-h]", m);
    if (hipsH && !hasHips) hipsH.hidden = true;
    function drawChart() {
      if (!chart) return;
      chart.innerHTML = rows
        .map(function (r) {
          var hips = !hasHips
            ? null
            : isNaN(r[4])
              ? "–"
              : fmt(r[4]) + "–" + fmt(r[5]) + " " + unit;
          return (
            '<tr class="' +
            (rec === r[0] ? "hl" : "") +
            '"><td>' +
            r[0] +
            "</td><td>" +
            r[1] +
            "</td><td>" +
            fmt(r[2]) +
            "–" +
            fmt(r[3]) +
            " " +
            unit +
            "</td>" +
            (hips === null ? "" : "<td>" + hips + "</td>") +
            "</tr>"
          );
        })
        .join("");
    }
    function setUnit(u) {
      if (u === unit) return;
      var v = parseFloat(waist.value);
      if (!isNaN(v))
        waist.value =
          u === "cm" ? Math.round(v * 2.54) : Math.round((v / 2.54) * 2) / 2;
      unit = u;
      if (unitLbl) unitLbl.textContent = u;
      waist.placeholder = u === "cm" ? "e.g. 81" : "e.g. 32";
      $$("[data-units] button", m).forEach(function (b) {
        b.classList.toggle("on", b.getAttribute("data-u") === u);
      });
      drawChart();
    }
    $$("[data-units] button", m).forEach(function (b) {
      b.addEventListener("click", function () {
        setUnit(b.getAttribute("data-u"));
      });
    });
    function tab(t) {
      $$(".sz-tabs button", m).forEach(function (b) {
        var on = b.getAttribute("data-tab") === t;
        b.classList.toggle("on", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      $$(".sz-pane", m).forEach(function (p) {
        p.hidden = p.getAttribute("data-pane") !== t;
      });
    }
    $$(".sz-tabs button", m).forEach(function (b) {
      b.addEventListener("click", function () {
        tab(b.getAttribute("data-tab"));
      });
    });
    var goto = $("[data-goto]", m);
    if (goto)
      goto.addEventListener("click", function (e) {
        e.preventDefault();
        tab("chart");
      });

    function showErr(msg) {
      err.textContent = msg;
      err.hidden = false;
    }
    function calc() {
      if (!rows.length) return;
      var v = parseFloat(String(waist.value).replace(",", "."));
      if (isNaN(v)) return showErr("Enter your waist measurement first.");
      var w = unit === "cm" ? v / 2.54 : v;
      if (w < 20 || w > 60)
        return showErr(
          unit === "cm"
            ? "Enter a waist between 51 and 152 cm."
            : "Enter a waist between 20 and 60 inches.",
        );
      err.hidden = true;
      var i = rows.findIndex(function (r) {
        return w <= r[3];
      });
      if (i < 0) i = rows.length - 1;
      var softEl = $(".sz-fit input:checked", m);
      var soft = softEl && softEl.value === "soft";
      var last = rows.length - 1;
      var edge = false;
      var gap = i > 0 && w > rows[i - 1][3] && w < rows[i][2];
      var pick = i,
        note;
      if (soft && i < last) {
        pick = i + 1;
        note =
          "Your waist fits " +
          rows[i][0] +
          ", but for a softer all-day feel we'd go one up. Still sculpts, less squeeze.";
      } else if (edge) {
        pick = i + 1;
        note =
          "You're at the top of " +
          rows[i][0] +
          " — " +
          rows[i + 1][0] +
          " will feel better from day one without losing the hold.";
      } else if (gap) {
        note =
          "You're between " +
          rows[i - 1][0] +
          " and " +
          rows[i][0] +
          " — we round up for an all-day comfortable fit that still sculpts.";
      } else if (w > rows[last][3]) {
        note =
          "You're above our largest range — " +
          rows[last][0] +
          " stretches a lot, but the hold will be very firm. Message us before ordering and we'll help.";
      } else if (w < rows[0][2]) {
        note =
          "You're below our smallest range — " +
          rows[0][0] +
          " will give a light, gentle hold.";
      } else {
        note =
          "Right in the middle of the range. Snug the first day, then it moulds to you.";
      }
      rec = rows[pick][0];
      $("[data-size-size]", m).textContent = rec;
      $("[data-size-head]", m).textContent =
        "Your best fit: " +
        rec +
        (rows[pick][1] ? " (US " + rows[pick][1] + ")" : "");
      $("[data-size-note]", m).textContent = note;
      var scale = $("[data-size-scale]", m);
      scale.style.setProperty("--n", rows.length);
      scale.innerHTML = rows
        .map(function (r, k) {
          var cls = k === pick ? "on" : k === i && i !== pick ? "alt" : "";
          return '<i class="' + cls + '">' + r[0] + "</i>";
        })
        .join("");
      res.hidden = false;
      res.scrollIntoView({ behavior: "smooth", block: "nearest" });
      if (applyBtn) applyBtn.textContent = "Use size " + rec + " →";
      drawChart();
    }
    $("[data-size-calc]", m).addEventListener("click", calc);
    waist.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        calc();
      }
    });

    function open() {
      lastFocus = document.activeElement;
      m.hidden = false;
      document.documentElement.classList.add("lv-modal-open");
      setTimeout(function () {
        try {
          waist.focus({ preventScroll: true });
        } catch (e) {
          waist.focus();
        }
      }, 30);
    }
    function close() {
      m.hidden = true;
      document.documentElement.classList.remove("lv-modal-open");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    opener.addEventListener("click", open);
    $("[data-size-close]", m).addEventListener("click", close);
    m.addEventListener("click", function (e) {
      if (e.target === m) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || m.hidden) return;
      close();
    });
    /* keep Tab inside the dialog */
    m.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;
      var f = $$(
        'button, [href], input, select, [tabindex]:not([tabindex="-1"])',
        m,
      ).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0],
        lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        lastEl.focus();
      } else if (!e.shiftKey && document.activeElement === lastEl) {
        e.preventDefault();
        first.focus();
      }
    });
    if (applyBtn) {
      applyBtn.addEventListener("click", function () {
        close();
        onApply(rec);
        if (applyBtn) applyBtn.textContent = applyDefault;
      });
    }
    drawChart();
    root._sizeModal = m;
  }

  /* ---------- Kaching: show progressive gifts inside each bundle bar ----------
     Display only. Kaching still decides which gifts go into the cart.
     Each unlocked gift is cloned from the bar's "+ FREE" row, and the separate
     "Free gift with your order" block is hidden. */
  function findGiftCfg() {
    var hit = null;
    function walk(o, d) {
      if (hit || !o || typeof o !== "object" || d > 8) return;
      if (o.progressiveGifts && Array.isArray(o.progressiveGifts.gifts)) {
        hit = o;
        return;
      }
      for (var k in o) walk(o[k], d + 1);
    }
    $$("script").some(function (s) {
      var t = s.textContent;
      if (t.indexOf('"progressiveGifts"') < 0) return false;
      try {
        walk(JSON.parse(t), 0);
      } catch (e) {}
      return !!hit;
    });
    return hit;
  }

  // Copy of Kaching's free-gift row (wash bag, 2026-10-27), used when no bar has a free gift.
  function giftRowTpl() {
    var d = document.createElement("div");
    d.innerHTML =
      '<div class="kaching-bundles__free-gift" style="--kaching-free-gift-background-color:rgba(240,240,240,1);--kaching-free-gift-text-color:rgba(0,0,0,1);--kaching-free-gift-selected-background-color:rgba(212,46,106,1);--kaching-free-gift-selected-text-color:rgba(255,255,255,1);--kaching-free-gift-font-size:13px;--kaching-free-gift-font-weight:bold;--kaching-free-gift-font-style:normal;--kaching-free-gift-image-border-radius:6px;--kaching-free-gift-image-height:30px;">' +
      '<div class="kaching-bundles__free-gift__main"><div class="kaching-bundles__free-gift__link">' +
      '<img class="kaching-bundles__free-gift__image" src="" alt="" width="30" height="30"></div>' +
      '<div class="kaching-bundles__free-gift__content"><span class="kaching-bundles__free-gift__text"></span></div></div>' +
      '<div class="kaching-bundles__free-gift__full-price"></div></div>';
    return d.firstChild;
  }

  function inlineGifts(slot) {
    if (slot._lvGifts) return;
    slot._lvGifts = true;
    var cfg = null,
      data = null,
      obs,
      queued = false;

    function readGifts(pg) {
      if (!cfg) cfg = findGiftCfg();
      if (!cfg || !cfg.progressiveGiftsEnabled) return null;
      var els = $$(".kaching-bundles__progressive-gifts__gift", pg);
      var gifts = cfg.progressiveGifts.gifts;
      if (!els.length || els.length !== gifts.length) return null;
      return gifts.map(function (g, i) {
        var el = els[i],
          img = $("img", el),
          title = $('[class*="progressive-gifts__gift__title"]', el),
          old = $('[class*="--crossed-out"]', el);
        return {
          at: g.unlockAtBar,
          only: g.unlockAtBarOnly,
          img: img ? img.getAttribute("src") : "",
          title: title ? title.textContent.trim() : "",
          price: old ? old.textContent.trim() : "",
        };
      });
    }

    function paint() {
      queued = false;
      var block = $(".kaching-bundles", slot),
        pg = block && $(".kaching-bundles__progressive-gifts", block);
      if (!pg) return;
      if (!data) data = readGifts(pg);
      if (!data) return;
      // Prefer a real Kaching "+ FREE" row (keeps its current colours); if no bar
      // has a free gift any more, build the same markup ourselves. Kaching's CSS
      // for these classes is global, so the row still looks the same.
      var tpl =
        $(".kaching-bundles__free-gift:not(.lv-pg-row)", block) || giftRowTpl();
      obs.disconnect();
      $$(".kaching-bundles__bars > .kaching-bundles__bar", block).forEach(
        function (bar, i) {
          var n = i + 1,
            box = $(".kaching-bundles__bar-container", bar) || bar,
            want = data.filter(function (g) {
              return g.only ? n === g.at : n >= g.at;
            }),
            have = $$(".lv-pg-row", box);
          if (
            have.length === want.length &&
            have.every(function (r, k) {
              return r.getAttribute("data-title") === want[k].title;
            })
          )
            return;
          have.forEach(function (r) {
            r.remove();
          });
          // clone a row from this bar so it gets the bar's selected/unselected colours
          var own =
            $(".kaching-bundles__free-gift:not(.lv-pg-row)", box) || tpl;
          want.forEach(function (g) {
            var row = own.cloneNode(true);
            row.classList.add("lv-pg-row");
            row.removeAttribute("data-free-gift-id");
            row.setAttribute("data-title", g.title);
            var a = $("a", row),
              im = $("img", row),
              tx = $(".kaching-bundles__free-gift__text", row),
              pr = $(".kaching-bundles__free-gift__full-price", row);
            if (a) {
              a.removeAttribute("href");
              a.removeAttribute("target");
            }
            if (im) {
              im.src = g.img;
              im.alt = g.title;
            }
            if (tx) tx.textContent = "+ FREE " + g.title;
            if (pr) pr.textContent = g.price;
            box.appendChild(row);
          });
        },
      );
      slot.classList.add("lv-gifts-inline");
      obs.observe(slot, { childList: true, subtree: true });
    }

    obs = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(paint);
    });
    obs.observe(slot, { childList: true, subtree: true });
    paint();
  }

  /* ---------------- boot + theme editor ---------------- */
  function boot(scope) {
    $$("[data-lv-product]", scope).forEach(init);
    $$("#lv-buy", scope).forEach(inlineGifts);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  else boot(document);

  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    var root = $("[data-lv-product]", e.target);
    var sid = root && root.getAttribute("data-section");
    if (sid)
      $$('[data-size-modal][data-owner="' + sid + '"]').forEach(function (m) {
        m.remove();
      });
  });
  document.addEventListener("shopify:block:select", function (e) {
    var root = e.target.closest("[data-lv-product]");
    if (root && root._miniGo && e.target.classList.contains("mini-card"))
      root._miniGo(e.target);
  });
})();
